export const getInitials = function (value?: string | null) {
  if (!value) {
    return '';
  }

  const newValue = value.replace(/[^0-9a-z]/gi, '');
  var names = newValue.split(' '),
    initials = (names[0] ?? '').substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1]?.substring(0, 1).toUpperCase();
  }

  if (initials.length <= 1) {
    return newValue.slice(0, 2).toUpperCase();
  }
  return initials.toUpperCase();
};
